import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { cn } from '@bem-react/classname'
import parse from 'html-react-parser'

import { VerifyCode } from '@/components/Form/VerifyCode'
import { Tag } from '@/components/UI/Tag'

import { RegisterCodeEmailModel } from '../../models/Register.model'
import './EmailCodeStep.scss'

interface IEmailCodeStepProps {
  className?: string
  onCompleted?: () => void
  value?: string
}

const cnEmailCodeStep = cn('EmailCodeStep')

export const EmailCodeStep: FC<IEmailCodeStepProps> = ({
  className,
  onCompleted,
  value,
}) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext<RegisterCodeEmailModel>()

  const onHandleChange = (value: string) => {
    if (value.length === 6 && onCompleted) onCompleted()
  }

  return (
    <div className={cnEmailCodeStep(null, [className])}>
      <Tag className={cnEmailCodeStep('title')}>
        {t('register-three-title')}
      </Tag>

      {value && (
        <div className={cnEmailCodeStep('text')}>
          {parse(
            t('register-second-text', {
              email: value,
            }),
          )}
        </div>
      )}

      <Controller
        name='email_code'
        control={control}
        render={({ field: { onChange } }) => (
          <VerifyCode
            placeholder=''
            onChange={value => {
              onChange(value)
              onHandleChange(value)
            }}
            errors={errors.email_code?.message}
            autoFocus
            // onCompleted={onCompleted}
          />
        )}
      />
    </div>
  )
}
